// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Footer_wrapper__2piYh","smLinksWrapper":"Footer_smLinksWrapper__8x1ww","normalLinks":"Footer_normalLinks__x6Qpz"};